import React, { useCallback, useEffect, useRef } from 'react'
import _get from 'lodash/get'
import DetailPageV3VideoPlayer from './DetailPageV3VideoPlayer'
import DetailPageV3Jumbotron from './DetailPageV3Jumbotron'

const MIN_FRAME_HEIGHT = 320
const DEFAULT_BOTTOM_OFFSET = 220
const ASPECT_RATIO = 1.778

/**
 * @param {Object} props - The props
 * @param {number} props.offsetBottom - The offset for the content below the module
 * @param {Map} props.detailData - The detail data
 * @param {Object} props.location - The location object
 * @param {Object} props.history - The history object
 * @param {Object} props.apolloClient - The Apollo client
 * @param {Object} props.ga4EventData - The GA4 event data
 * @returns {JSX.Element} DetailPageV3TopModule
 */

const DetailPageV3TopModule = (props) => {
  const {
    offsetBottom = DEFAULT_BOTTOM_OFFSET,
    detailData,
    location,
    history,
    apolloClient,
    ga4EventData,
  } = props

  const frameRef = useRef()
  const shouldShowPlayer = !!_get(location, ['query', 'fullplayer'])

  const setFrameDimensions = useCallback(() => {
    const screenWidth = global.innerWidth
    const screenHeight = global.innerHeight
    const frameOffsetTop = (frameRef.current.getBoundingClientRect()?.top || 0) + global.scrollY
    const expectedFrameHeight = screenHeight - frameOffsetTop - offsetBottom

    // Do not adjust frame dimensions in portrait orientation
    if (screenHeight > screenWidth) {
      frameRef.current.style.height = 'unset'
      frameRef.current.style.width = '100%'
      return
    }

    if (screenHeight - frameOffsetTop < MIN_FRAME_HEIGHT
      || expectedFrameHeight < MIN_FRAME_HEIGHT) {
      frameRef.current.style.height = `${MIN_FRAME_HEIGHT}px`
      frameRef.current.style.width = 'unset'
      return
    }

    if (expectedFrameHeight * ASPECT_RATIO > screenWidth) {
      frameRef.current.style.height = 'unset'
      frameRef.current.style.width = '100%'
      return
    }

    frameRef.current.style.height = `${expectedFrameHeight}px`
    frameRef.current.style.width = 'unset'
  }, [offsetBottom])

  useEffect(() => {
    setFrameDimensions()
    global.addEventListener('resize', setFrameDimensions)
    return () => {
      global.removeEventListener('resize', setFrameDimensions)
    }
  }, [setFrameDimensions])

  return (
    <div className="detail-page-v3__top-module">
      <div ref={frameRef} className="detail-page-v3__top-module-frame">
        {shouldShowPlayer
          ? <DetailPageV3VideoPlayer
              detailData={detailData}
              location={location}
              history={history}
              apolloClient={apolloClient}
            />
          : <DetailPageV3Jumbotron detailData={detailData} ga4EventData={ga4EventData} />
        }
      </div>
    </div>
  )
}

export default DetailPageV3TopModule
